import { NoopTracker } from "@dpdgroupuk/react-event-tracker";

export default new NoopTracker({
  projectRef: "CR",
  debug: process.env.NODE_ENV === "development",
});
